import {
  AsYouType,
  CountryCode,
  format,
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  parsePhoneNumberWithError,
  PhoneNumber
} from 'libphonenumber-js';
import { isNullOrUndefined } from './util';

export class PhoneNumberUtil {
  static getCountryCode(phoneNumber: string): CountryCode {
    const parsedPhoneNumber: PhoneNumber = this.parsePhoneNumber(phoneNumber, 'US');
    if (isNullOrUndefined(parsedPhoneNumber)) {
      return null;
    }
    return parsedPhoneNumber.country;
  }

  static asYouType(phoneNumber: string, countryCode: CountryCode): string {
    return phoneNumber ? new AsYouType(countryCode).input(phoneNumber.toString()) : '';
  }

  /**
   * Checks phone number length with isPossiblePhoneNumber(), and checks against all available
   * regular expressions with isValidPhoneNumber().
   * @param phoneNumber
   * @param countryCode
   */
  static isValidPhoneNumber(phoneNumber: string, countryCode: CountryCode): boolean {
    const parsedPhoneNumber: PhoneNumber = this.parsePhoneNumber(phoneNumber, countryCode);
    if (!isNullOrUndefined(parsedPhoneNumber)) {
      return isPossiblePhoneNumber(parsedPhoneNumber.number, countryCode) && isValidPhoneNumber(parsedPhoneNumber.number, countryCode);
    }
    return false;
  }

  static parsePhoneNumber(phoneNumber: string, countryCode: CountryCode): PhoneNumber {
    try {
      return parsePhoneNumberWithError(phoneNumber, countryCode);
    } catch (err) {
      return null;
    }
  }

  static formatPhoneNumberForRest(phoneNumber: string, countryCode: CountryCode): string {
    return format(this.parsePhoneNumber(phoneNumber, countryCode).number, countryCode, 'E.164');
  }

  static formatPhoneNumberForDisplay(phoneNumber: string, countryCode: CountryCode): string {
    return format(this.parsePhoneNumber(phoneNumber, countryCode).number, countryCode, 'NATIONAL');
  }
}
